import styled, { css } from 'styled-components';

import { Search as UISearch, mediaQuery } from '@catalyze/ui';
import { CheckboxRow } from 'components/CheckboxRow';

export const Container = styled.div`
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto auto auto;
    grid-template-areas: 'search' 'dropdowns' 'tags';
    row-gap: 0.75rem;
    column-gap: 1rem;
    padding: 1.5rem;
    ${mediaQuery(
        1,
        css`
            grid-template-columns: 1fr auto;
            grid-template-rows: auto auto;
            grid-template-areas: 'search dropdowns' 'tags tags';
        `
    )}
`;

export const TagContainer = styled.div`
    grid-area: tags;

    & > * {
        margin-bottom: 0.25rem;

        &:not(:last-child) {
            margin-right: 0.25rem;
        }
    }
`;

export const Search = styled(UISearch)`
    grid-area: search;
    margin-top: 0.0625rem;
    width: 100%;

    & input {
        height: 2.375rem;
    }
`;

export const DropdownContainer = styled.div`
    grid-area: dropdowns;
    display: flex;
    flex-shrink: 1;
`;

export const StyledCheckboxRow = styled(CheckboxRow)`
    padding: 1.5rem;
`;

export const Divider = styled.hr`
    border: none;
    border-top: 1px solid ${({ theme }) => theme.colors.lightShadow};
    margin: 0 1.5rem 0.5rem 1.5rem;
`;
